import { useState, useCallback, useRef, useEffect } from 'react';

export function useClipboard(resetDelay = 2000) {
  const [copiedValue, setCopiedValue] = useState<string | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  const copy = useCallback(async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedValue(text);
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setCopiedValue(null), resetDelay);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  }, [resetDelay]);

  const isCopied = useCallback((text: string) => copiedValue === text, [copiedValue]);

  const copied = copiedValue !== null;

  return { copied, copy, isCopied };
}
